import { render, staticRenderFns } from "./DepositDetailTemp.vue?vue&type=template&id=b35faa1e&scoped=true&"
import script from "./DepositDetailTemp.vue?vue&type=script&lang=js&"
export * from "./DepositDetailTemp.vue?vue&type=script&lang=js&"
import style0 from "./DepositDetailTemp.vue?vue&type=style&index=0&id=b35faa1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35faa1e",
  null
  
)

export default component.exports